import API from 'util/API';

// get all printers
export const getAllMerchantPrinters = async () => {
  const response = await API.get('/admin/printers');
  return response.data;
};

export const getPrinters = async () => {
  const response = await API.get('/myprinters');
  if (response && response.data && response.data.printers) {
    return response.data.printers;
  }
  return [];
};

export const updatePrinter = async (printer) => {
  const response = await API.put(`/printer/${printer.printerName}`, {printer});
  if (response && response.data && response.data.printer) {
    return response.data.printer;
  }
  return null;
};

export const createPrinter = async (printer) => {
  const response = await API.post('/printer', printer);
  if (response && response.data && response.data.printer) {
    return response.data.printer;
  }
  return null;
};

export const deletePrinter = async (printerId) => {
  const response = await API.delete(`/printer/${printerId}`);
  if (response && response.data && response.data.printer) {
    return response.data.printer;
  }
  return null;
};


export const getTableInfo = async () => {
  const response = await API.get('/tableInfo');
  if (response && response.data && response.data.tableInfo) {
    return response.data.tableInfo;
  }
  return null;
};

// get printerZones
export const getPrinterZones = async () => {
  const response = await API.get('/printerZones');
  if (response && response.data && response.data) {
    return response.data;
  }
  return [];
};

// update printerZone
export const updatePrinterZone = async (zone) => {
   await API.post(`/printerZone/${zone.id}`, zone);
};

// create printerZone
export const createPrinterZone = async (zone) => {
   await API.post(`/printerZone`, zone);
};

// delete printerZone
export const deletePrinterZone = async (zoneId) => {
   await API.delete(`/printerZone/${zoneId}`);
};




